// controllers.js
var Controllers = pc.createScript('controllers');

Controllers.attributes.add('controllerTemplate', {
    type: 'entity',
    title: 'Controller Template'
});

Controllers.attributes.add('cameraParent', {
    type: 'entity',
    title: 'Camera Parent'
});

Controllers.prototype.initialize = function() {
    // when controller is added
    this.app.xr.input.on('add', function (inputSource) {
        // clone controller entity template
        var entity = this.controllerTemplate.clone();
        // set input source
        entity.script.controller.setInputSource(inputSource);
        // reparent to camera parent entity
        entity.reparent(this.cameraParent);
        entity.enabled = true;
        // correctly identify controllers
        var hand = inputSource.handedness;
        this.app.fire('controller:register', entity, hand);
    }, this);
};

//        var anim = entity.children[2];
//        var men = entity.children[3];
//        var hand = inputSource.handedness;
//        //this.app.fire('debug', 'inputSourceName:', inputSource.handedness, 0);
//        this.app.fire('controllers:clones', anim, men, hand);

